export function trackEvent(eventType, options = {}) {
  const { refer, channel, extraData = {} } = options;
  // 自定义 CRM 埋点
  if (eventType !== 'Purchase') {
    crmTrack(eventType, refer, channel);
  }

  // Facebook Pixel 埋点
  if (typeof fbq !== 'undefined') {
    console.log(mapEventType(eventType, 'fbq'))
    fbq('track', mapEventType(eventType, 'fbq'), {
      eventID: `${eventType}_${Date.now()}`,
      ...extraData.fbq, // 可额外传参
    });
  }

  // tiktok 埋点
  if (typeof ttq !== 'undefined') {
    ttq.track(mapEventType(eventType, 'ttq'), {
      ...extraData.ttq, // 可额外传参
    });
  }

}

// 可选：统一不同渠道的事件名映射
function mapEventType(eventType, channel) {
  const map = {
    add_cart: {
      fbq: 'AddToCart',
      ttq: 'AddToCart',
    },
    add_user_info: {
      fbq: 'InitiateCheckout',
      ttq: 'InitiateCheckout',
    },
    add_pay: {
      fbq: 'AddPaymentInfo',
      ttq: 'AddPaymentInfo',
    },
    Purchase: {
      fbq: 'Purchase',
      ttq: 'Purchase',
    },
    // 可扩充更多事件
  };

  return map[eventType]?.[channel] || eventType;
}

function crmTrack(type, refer, channel_id, message = '') {
  var postParams = {
    channel_id: channel_id,
    token: refer,
    type: type,
    message: message,
  }
  fetch('https://crm.heomai.com/api/user/action', {
    body: JSON.stringify(postParams),
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
  })
}
